<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
    >
      <el-table-column prop="name" label="药品通用名" width="180"></el-table-column>
      <el-table-column prop="barcode" label="药品条形码"></el-table-column>
      <el-table-column prop="spec" label="药品规格"></el-table-column>
      <el-table-column prop="unit" label="包装单位"></el-table-column>
      <!--      <el-table-column prop="drugUsage" label="用法"></el-table-column>-->
      <el-table-column prop="usageFrequencyName" label="使用频次"></el-table-column>
      <el-table-column prop="perNum" label="每次用量"></el-table-column>
      <el-table-column prop="perUnit" label="用量单位"></el-table-column>
      <el-table-column prop="takingDay" label="用药天数"></el-table-column>
      <el-table-column label="操作">
        <template #default="{ row: { spuId, skuId } }">
          <span class="btn" @click="goViewDrug(spuId, skuId)">查看</span>
          <span class="btn" @click="goEditDrug(spuId, skuId)">编辑</span>
          <span class="btn" @click="deleteDrug(spuId, skuId)">删除</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @current-change="val => $emit('handle-pageNo', val)"
        @size-change="val => $emit('handle-pageSize', val)"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'drugsManagement',
  props: {
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array
    }
  },
  methods: {
    deleteDrug(companySpuId, companySkuId) {
      this.$confirm('删除药品，将把该药品从药店药品库移除', '确认删除药品', {
        confirmButtonText: '我再想想',
        cancelButtonText: '删除',
        customClass: 'confirm',
        distinguishCancelAndClose: true,
        center: true
      })
        .then(() => {})
        .catch(type => {
          if (type === 'cancel') {
            Fetch.deleteCompanyDrugByBarcodeOrSpuId({ companySpuId, companySkuId }).then(() => this.$emit('refresh'));
          }
        });
    },
    goEditDrug(spuId, skuId) {
      if (skuId) {
        this.$router.push(`/drugsManagement/edit/${spuId}/${skuId}`);
      } else {
        this.$router.push(`/drugsManagement/edit/${spuId}`);
      }
    },
    goViewDrug(spuId, skuId) {
      if (skuId) {
        this.$router.push(`/drugsManagement/view/${spuId}/${skuId}`);
      } else {
        this.$router.push(`/drugsManagement/view/${spuId}`);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: #1e8dff;
  font-size: 12px;
  cursor: pointer;

  & + .btn {
    margin-left: 5px;
  }
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
</style>
